import React, { useState } from "react";
import { WhatsAppOutlined } from "@ant-design/icons";

const WhatsAppFloatButton = ({
  phoneNumber = "+6285265378528",
  message = "Hai *PT. Gema Mitra Suksesindo*, saya ingin bertanya tentang produk Anda.",
}) => {
  const [hovered, setHovered] = useState(false);

  const handleClick = () => {
    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(
      message
    )}`;
    window.open(url, "_blank");
  };

  return (
    <div className="fixed bottom-6 right-6 z-50">
      <div
        className="relative flex flex-col items-end group"
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
      >
        {/* Chat Bubble ala WhatsApp */}
        {hovered && (
          <div className="mb-2 max-w-[240px] px-4 py-2 bg-white border border-[#25D366] text-gray-800 text-sm rounded-xl shadow-lg animate-fade-in relative">
            Mau bertanya produk? <br /> Silakan klik WhatsApp
            {/* Tail bubble */}
            <div className="absolute bottom-[-6px] right-4 w-3 h-3 bg-white border-b border-r border-[#25D366] rotate-45" />
          </div>
        )}

        {/* WhatsApp Button */}
        <div
          onClick={handleClick}
          className="w-14 h-14 bg-[#25D366] rounded-full flex items-center justify-center cursor-pointer shadow-lg hover:scale-105 transition-transform duration-200"
        >
          <WhatsAppOutlined style={{ fontSize: 28, color: "white" }} />
        </div>
      </div>
    </div>
  );
};

export default WhatsAppFloatButton;
